// extracted by mini-css-extract-plugin
export default {"addByTxt":"SingleArticleFooter_addByTxt__fcWG-","date":"SingleArticleFooter_date__UPMsf"};